<template>
  <div
    class="message-tab"
    @click="()=>{showSelect=false}">
    <div class="flex-sb-center pd-b-15">
      <h1>Log</h1>
      <div>
        <v-button
          size="small"
          :gray="true"
          :stop="true"
          @click="handleShowSelect"
        >
          <span class="flex-sb-center">
            <span>{{selectName}}</span>
            <span class="mg-l-10">
              <font-awesome-icon
                class="color-gray position-center"
                icon="sort-down" />
            </span>
          </span>
        </v-button>
        <select-group
          v-model="showSelect"
          :list="sortList"
          :select-id="select_sort"
          @select="handleSelctSort">
        </select-group>
      </div>
    </div>
    <div class="wrapper">
      <span
        v-if="messageData.length < 1"
        class="no-data">No Data</span>
      <div
        v-for="(item, index) in messageData"
        :key="index"
        class="message-box">
        <div class="content">
          <span class="top flex-sb">
            <div class="left">
              <div
                v-if="item.sender_type == 1||item.sender_type==3"
                class="send-msg">
                <span class="cs">
                  <font-awesome-icon
                    :icon="item.sender_type==3?'robot':'headset'"
                    class="icon" />
                  {{item.sender_type==3?'HoverCover':item.agent}}
                </span>
                <span class="arrow">
                  <font-awesome-icon icon="arrow-right" />
                </span>
                <span class="customer">
                  <font-awesome-icon
                    icon="user"
                    class="icon" />
                  {{customerData.nick_name}}
                </span>
              </div>
              <!--              <span-->
              <!--                v-if="item.sender_type == 1"-->
              <!--                class="cs">-->
              <!--                <font-awesome-icon-->
              <!--                  icon="headset"-->
              <!--                  class="icon" />-->
              <!--                {{item.agent}}-->
              <!--              </span>-->

              <span
                v-else-if="item.sender_type == 2"
                class="customer">
                <font-awesome-icon
                  icon="user"
                  class="icon" />
                {{item.agent}}
                <!--                {{customerData.nick_name}}-->
              </span>

            </div>

            <div class="right">
              <span class="time">{{ item.created_at }}</span>
            </div>
          </span>

          <div class="message">
            <div
              v-if="[303,305,308].includes(item.comm_type)"
              class="send">
              <div class="title">
                <font-awesome-icon
                  :icon="item.comm_type==303?'sms':'envelope'"
                  class="icon"/>{{item.comm_type==308?item.title:`Send ${item.title}`}}
              </div>
              <div
                class="info"
                v-html="item.comm_vl"></div>
              <p
                v-if="item.comm_type==305"
                class="blue_2 pointer fs-14 fw-400 mg-t-5"
                @click="handlerEmail(item.sms_log_id)">
                View Full Message
              </p>
            </div>
            <div
              v-else-if="item.message_id!=0&&item.comm_type==301"
              class="send">
              <div class="title">
                <font-awesome-icon
                  icon="bell"
                  class="icon"/>Send {{item.title}}
              </div>
              <div
                class="info"
                v-html="item.comm_vl"></div>
            </div>
            <div
              v-else
              class="msg">
              <span v-html="item.comm_vl"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
    <log-email-popup
      v-model="showEmailDialog"
      :sms-log-id="sme_log_id"></log-email-popup>
  </div>
</template>
<script>
import MixinOptions from '@/mixins/options'
import { getAccountMessageList } from '@/api/account'
import selectGroup from '@/views/components/dialogs/select-group'
import logEmailPopup from '@/views/accounts/components/popup/logEmailPopup'
export default {
  name: 'Message',
  components:{
    selectGroup,
    logEmailPopup
  },
  mixins: [MixinOptions],
  props: {
    // customerId: [String, Number],
    // detailData: {
    //   type: Object,
    //   default: () => {}
    // }
  },
  inject:['customer_id', 'detailData'],
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      messageData: [],
      showSelect:false,
      select_sort:'desc',
      showEmailDialog:false,
      sme_log_id:0
    }
  },
  computed:{
    selectName(){
      let res = ''
      this.sortList.some(item=>{
        if(item.id==this.select_sort){
          res = item.name
          return true
        }else return false
      })
      return res
    },
    sortList(){
      return[
        {
          id:'desc',
          name:'Newest First'
        },
        {
          id:'asc',
          name:'Oldest First'
        }
      ]
    },
    customerId(){
      return this.customer_id()
    },
    detailDatas(){
      return this.detailData()
    },
    customerData(){
      return this.detailDatas.customer_profile
    }
  },
  created() {
    this.network().getAccountMessageList()
  },
  methods: {
    handlerEmail(sms_log_id){
      this.sme_log_id = sms_log_id
      this.showEmailDialog = true
    },
    handleSelctSort(id){
      this.select_sort = id
      this.showSelect = false
      this.updateData()
    },
    handleShowSelect(){
      this.showSelect = !this.showSelect
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getAccountMessageList()
    },
    updateData() {
      this.pageConfig.currentPage = 1
      this.network().getAccountMessageList()
    },
    network() {
      return {
        getAccountMessageList: async () => {
          const { data } = await getAccountMessageList({
            customer_id: this.customerId,
            sort:this.select_sort,
            page: this.pageConfig.currentPage
          })
          this.messageData = data.data
          this.pageConfig.total = data.total
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.message-tab {
  color: #616266;
  h1 {
    padding-bottom: 0;
    font-size: 20px;
  }
  ::v-deep .btn-gray{
    min-width: 136px;
  }
  .mg-l-10{
    margin-left: 10px;
  }
  .position-center{
    position: relative;
    transform: translate(25%, -25%);
  }
  .wrapper {
    .no-data {
      display: block;
      margin-top: 20px;
      text-align: center;
    }
    .message-box {
      margin-bottom: 15px;
      .content {
        border-bottom: 1px solid #E1E4E8;
        padding-bottom: 15px;
        .top{
          .left{
            .icon{
              margin-right: 8px;
            }
            .send-msg{
              .arrow{
                margin: 0 13px 0 12px;
              }
            }
          }
          .right{
            .time{
              color: #6A737D;
            }
          }
        }
        .message{
          margin-top: 5px;
          .send{
            background: #F6F8FA;
            border-radius: 6px;
            padding: 10px;
            .title{
              font-weight: 600;
              font-size: 14px;
              line-height: 20px;
              color: #6A737D;
              .icon{
                margin-right: 9px;
              }
            }
            .info{
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #24292E;
            }
          }
          .msg{
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #24292E;
          }
        }
      }
    }
  }
}
</style>
